/** @jsxImportSource @emotion/react */
import { css } from "@emotion/react";
import { FunctionComponent } from "react";

import { StrapiPricingPlan } from "@/types/strapi";

import { ButtonVariantKeys } from "@/tokens/configs/button_config";
import { Spacing } from "@/tokens/spacing";

import { Button } from "@/ui/atoms/button";
import { Text } from "@/ui/atoms/text";

import { formatPrice } from "@/util/data_util";
import { getPricingPlanCtaTrack } from "@/util/pricing_util";
import { buildStylesByBreakpoint } from "@/util/style_util";

export const PricingMatrixPlanHeaderColumn: FunctionComponent<
    StrapiPricingPlan
> = (props) => {
    /**
     * Styles
     */
    const pricingCostStyles = css({
        alignItems: "baseline",
        display: "flex",
        gap: Spacing["spacing-2"],
        justifyContent: "center",
        marginBottom: Spacing["spacing-1"],
    });

    const planColumnStyles = css({
        alignItems: "stretch",
        display: "flex",
        flexBasis: "1px",
        flexDirection: "column",
        flexGrow: "1",
        justifyContent: "space-between",
        padding: `${Spacing["spacing-4"]} 0`,
    });

    const pricingCTAStyles = css({
        display: "flex",
        flexDirection: "column",
        flexGrow: "1",
        justifyContent: "space-between",
    });

    const pricingCTAButtonStyles = css(
        {
            justifyContent: "center",
        },
        buildStylesByBreakpoint("display", {
            extraSmall: "none",
            medium: "flex",
        }),
    );

    /**
     * Rendering
     */
    const renderPlanPricingDetails = () => {
        return (
            <div>
                <div css={pricingCostStyles}>
                    <Text
                        fontSize="PricingMatrixPlanPricingMain"
                        fontWeight="medium"
                        themeKey="headlinePrimary"
                    >
                        {props.Price_Override ||
                            (props.Price_Annual &&
                                formatPrice(props.Price_Annual))}
                    </Text>

                    {props.Price_Annual && props.Price_Annual > 0 && (
                        <Text
                            fontSize="PricingMatrixPlanPricingDesc"
                            themeKey="textPrimary"
                        >
                            / user / mo
                        </Text>
                    )}
                </div>

                {props.Price_Monthly && (
                    <Text
                        fontSize="PricingMatrixPlanPricingMonthly"
                        textAlign="center"
                        themeKey="textPrimary"
                    >
                        {formatPrice(props.Price_Monthly)} billed monthly
                    </Text>
                )}
            </div>
        );
    };

    return (
        <div css={planColumnStyles}>
            <Text
                fontSize="PricingMatrixPlanName"
                textAlign="center"
                themeKey="headlinePrimary"
            >
                {props.Name}
            </Text>

            <div css={pricingCTAStyles}>
                {renderPlanPricingDetails()}

                <Button
                    className={pricingCTAButtonStyles}
                    fontSize="CtaDefault"
                    href={props.CTA.URL}
                    marginTop="PricingMatrixStickyNavMarginTop"
                    track={getPricingPlanCtaTrack(props)}
                    variant={
                        props.CTA.Appearance.toLowerCase() as
                            | ButtonVariantKeys
                            | undefined
                    }
                >
                    {props.CTA.Text}
                </Button>
            </div>
        </div>
    );
};
